declare global {
  interface Window {
    ELFSIGHT?: {
      init: () => void;
    };
  }
}
import { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import Image from 'next/image';
import {
  CITIES_DROPDOWN,
  CITIES_DROPDOWN_INTERFACE,
  FETCH_REVIEWS,
  FETCH_REVIEWS_INTERFACE
} from '../../api/reviews';
import Script from 'next/script';
import { REVIEWS_PAGE, REVIEWS_PAGE_INTERFACE } from '../../api/reviewsPage';
import ReviewsHeader from '../../components/Reviews/Header';
import ReviewsFilterNav from '../../components/Reviews/ReviewsFilternav';
import DisplayReviews from '../../components/Reviews/DisplayReviews';
import FooterAbout from '../../components/Reviews/FooterAbout';
const Newsletter = dynamic(() => import('../../layouts/Newsletter/Newsletter'));
import Adventure from '../../components/Reviews/Adventure';
import Head from 'next/head';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import ReviewRequest from '../../components/Review/ReviewRequest';
import client from '../../apollo-client';
import { replaceTripshepherdWithSeeSight } from '../../utils/trip-sheppered-text';
import ReviewTabs from '../../components/Reviews/ReviewTab';

interface IProps {
  reviewsPage: REVIEWS_PAGE_INTERFACE['reviewsPage'];
  citiesPageDropDown: CITIES_DROPDOWN_INTERFACE;
}
const filterOptions: any = {
  Newest: {
    order_by: [{ created_at: 'desc' }]
  },
  Oldest: {
    order_by: [{ created_at: 'asc' }]
  },
  Highest: {
    order_by: [{ rating: 'desc' }, { created_at: 'desc' }]
  },
  Lowest: {
    order_by: [{ rating: 'asc' }, { created_at: 'desc' }]
  }
};
const Reviews = ({ reviewsPage, citiesPageDropDown }: IProps) => {
  const [externalReviewCount, setExternalReviewCount] = useState<number>(0);
  const [externalReviewRating, setExternalReviewRating] = useState<number>(0);
  const [websiteReviewCount, setWebsiteReviewCount] = useState<number>(0);
  const [websiteReviewRating, setWebsiteReviewRating] = useState<number>(0);
  const [activeTab, setActiveTab] = useState<'website' | 'platform'>('website');
  const [sortOrder, setSortOrder] = useState<string>('Newest');
  const [currentPage, setCurrrentPage] = useState<number>(0);
  const [cityFilter, setCityFilter] = useState<any>(null);
  const [citiesToggle, setCitiesToggle] = useState<boolean>(false);
  const [sortToggle, setSortToggle] = useState<boolean>(false);
  const [refetch, setRefetch] = useState<boolean>(false);
  const [totalReviewsData, setTotalReviewsData] = useState<any>(null);
  const router = useRouter();
  const reviewId = router.query.id;

  useEffect(() => {
    if (totalReviewsData?.reviewsConnection?.aggregate?.avg) {
      setWebsiteReviewRating(
        Number(
          parseFloat(
            totalReviewsData?.reviewsConnection?.aggregate?.avg?.rating
          ).toFixed(1)
        )
      );
      setWebsiteReviewCount(
        totalReviewsData?.reviewsConnection?.aggregate?.count
      );
    }
  }, [totalReviewsData]);
  useEffect(() => {
    const timeout = setTimeout(() => {
      const countElement = document.querySelector(
        '.es-header-rating-reviews-count'
      );
      if (countElement?.textContent) {
        const cleanedCount = countElement?.textContent
          ?.replace(/[(),]/g, '')
          ?.trim();
        const parsed = parseInt(cleanedCount);
        if (!isNaN(parsed)) {
          setExternalReviewCount(parsed);
        }
      }
      const ratingElement = document.querySelector('.es-rating-value');

      if (ratingElement?.textContent) {
        const parsedRating = parseFloat(ratingElement?.textContent?.trim());
        if (!isNaN(parsedRating)) {
          setExternalReviewRating(parsedRating);
        }
      }
    }, 5000);

    return () => clearTimeout(timeout);
  }, []);
  useEffect(() => {
    client
      .query<FETCH_REVIEWS_INTERFACE>({
        query: FETCH_REVIEWS,
        variables: {
          where: { date: { _is_null: false } },
          limit: 10,
          offset: 0
        }
      })
      .then(({ data }) => {
        setTotalReviewsData(data);
      });
  }, []);
  //fetching queries
  const [
    fetchReviews,
    {
      data: totalReviews,
      error: fetchReviewsError,
      loading: fetchReviewsLoading,
      refetch: refetchReviews
    }
  ] = useLazyQuery<FETCH_REVIEWS_INTERFACE>(FETCH_REVIEWS);
  useEffect(() => {
    const whereCondition =
      cityFilter?.cities?.id !== undefined && cityFilter?.cities?.id !== 0
        ? {
            parentproduct: {
              boat: {
                cities_products: {
                  city: { strapi_city: { id: { _eq: cityFilter?.cities?.id } } }
                }
              }
            },
            date: { _is_null: false }
          }
        : { date: { _is_null: false } };

    fetchReviews({
      variables: {
        offset: currentPage * 20,
        limit: 20,
        order_by: filterOptions[sortOrder]?.order_by,
        cityObject: cityFilter,
        where: whereCondition
      }
    });
    if (refetch) {
      refetchReviews();
      setRefetch(false);
    }
  }, [cityFilter, sortOrder, currentPage, cityFilter?.cities?.id, refetch]);

  useEffect(() => {
    const handleScroll = () => {
      setCitiesToggle(false);
      setSortToggle(false);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const handleClick = () => {
    const reviewTabs = document.getElementById('reviewTabs');
    if (reviewTabs) {
      reviewTabs?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  const [widgetLoaded, setWidgetLoaded] = useState(false);

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_MODE === 'LIVE') {
      const loadWidget = () => {
        if (!window.ELFSIGHT) {
          const script = document.createElement('script');
          script.src = 'https://static.elfsight.com/platform/platform.js';
          script.async = true;
          script.id = 'widget-elf';
          document.body.appendChild(script);

          script.onload = () => {
            setWidgetLoaded(true);
            if (window.ELFSIGHT) {
              window.ELFSIGHT.init();
            }
          };

          script.onerror = () => {
            console.error('Failed to load ELF widget script');
          };
        } else {
          setWidgetLoaded(true);
        }
      };

      loadWidget();

      return () => {
        const script = document.getElementById('widget-elf');
        if (script) {
          script.remove();
        }
      };
    }
  }, []);

  return (
    <>
      <Head>
        <meta
          name="og:title"
          content={replaceTripshepherdWithSeeSight(reviewsPage?.pageTitle)}
        />
        <meta
          name="og:description"
          key="metadescription"
          content={
            'Discover what travelers love about See Sight Tours! Read real reviews about our personalized, small-group guided tours and unforgettable experiences. '
          }
        />
        <title>{replaceTripshepherdWithSeeSight(reviewsPage?.pageTitle)}</title>
        <meta
          name="description"
          key="metadescription"
          content={
            'Discover what travelers love about See Sight Tours! Read real reviews about our personalized, small-group guided tours and unforgettable experiences. '
          }
        />
        <meta name="og:image" content="/vertical-seesight-logo.png" />
        {/* <meta name="viewport" content="width=device-width, initial-scale=1" /> */}
        <link
          href={replaceTripshepherdWithSeeSight(reviewsPage?.canonical)}
          rel="canonical"
          key="canonical"
        />
        {process.env.NEXT_PUBLIC_MODE === 'LIVE' && !widgetLoaded && (
          <Script
            src="https://static.elfsight.com/platform/platform.js"
            strategy="afterInteractive"
            async
            id="widget-elf"
            onLoad={() => setWidgetLoaded(true)}
          />
        )}
      </Head>
      <div
        onClick={() => {
          if (citiesToggle) {
            setCitiesToggle(false);
          }
          if (sortToggle) {
            setSortToggle(false);
          }
        }}
        className="relative pb-16 reviews-page"
      >
        <ReviewsHeader
          externalReviewCount={externalReviewCount}
          externalReviewRating={externalReviewRating}
          websiteReviewCount={websiteReviewCount}
          websiteReviewRating={websiteReviewRating}
        />
        <ReviewTabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          externalReviewCount={externalReviewCount}
          externalReviewRating={externalReviewRating}
          websiteReviewCount={websiteReviewCount}
          websiteReviewRating={websiteReviewRating}
        />

        <div className={`${activeTab === 'website' ? 'block' : 'hidden'}`}>
          <ReviewsFilterNav
            cityFilter={cityFilter}
            setCityFilter={setCityFilter}
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
            citiesPageDropDown={citiesPageDropDown?.citiesPage?.cities || []}
            citiesToggle={citiesToggle}
            setCitiesToggle={setCitiesToggle}
            sortToggle={sortToggle}
            setSortToggle={setSortToggle}
            currentPage={currentPage}
            setCurrentPage={setCurrrentPage}
            citiesDropDown={citiesPageDropDown?.citiesPage || {}}
            setRefetch={setRefetch}
          />
          <DisplayReviews
            currentPage={currentPage}
            setCurrentPage={setCurrrentPage}
            totalReviews={totalReviews ? totalReviews : {}}
            fetchReviewsLoading={fetchReviewsLoading}
          />
        </div>
        {process.env.NEXT_PUBLIC_MODE === 'LIVE' && (
          <div style={{ display: activeTab === 'platform' ? 'block' : 'none' }}>
            <div className="mx-auto w-[288px] xsm:w-[340px] md:w-[700px] xl:w-[1000px] 2xl:w-[1332px] py-6 rounded-lg justify-start md:gap-x-4 gap-y-6">
              <div className="elfsight-app-1df5d44e-350f-49b0-83f3-2974a31153c1"></div>
            </div>
          </div>
        )}
        <div className="w-full text-right mt-0 pt-0">
          <button onClick={handleClick} className="rotate-90 mr-10 ml-auto">
            <Image
              src={'./left-arrow-blue.svg'}
              alt="bring to top arrow"
              width={24}
              height={24}
              className="w-full h-full"
            />
          </button>
        </div>

        <FooterAbout reviewPage={reviewsPage} />
        <Adventure />
        <Newsletter />
        {reviewId && reviewId?.length > 4 && <ReviewRequest id={reviewId} />}
      </div>
    </>
  );
};

export async function getServerSideProps() {
  const {
    data: { reviewsPage } = {},
    loading,
    error
  } = await client.query<REVIEWS_PAGE_INTERFACE>({
    query: REVIEWS_PAGE
  });

  const { data: citiesPageDropDown, error: citiesDropdownError } =
    await client.query<CITIES_DROPDOWN_INTERFACE>({
      query: CITIES_DROPDOWN
    });

  return {
    props: {
      reviewsPage:
        reviewsPage &&
        JSON.parse(
          replaceTripshepherdWithSeeSight(JSON.stringify(reviewsPage))
        ),
      citiesPageDropDown:
        citiesPageDropDown &&
        JSON.parse(
          replaceTripshepherdWithSeeSight(JSON.stringify(citiesPageDropDown))
        )
    }
  };
}

export default Reviews;
